import Formatter from '@/functions/Formatter';

export default class Image {
    constructor(small, medium, large, original, width, height, id = null, fileName = ''){
        this.small = Formatter.getCompleteUrl(small);
        this.medium = Formatter.getCompleteUrl(medium);
        this.large = Formatter.getCompleteUrl(large);
        this.original = Formatter.getCompleteUrl(original);
        this.id = id;
        this.width = width;
        this.height = height;
        this.fileName = fileName;
        this.niceName = '';
        this.extenstion = '';
        if(fileName){
            this.extension =  '.' + fileName.split('.').pop();
            this.niceName = fileName.substring(0, fileName.length - this.extension.length);
        }

        if(!this.medium) this.medium = this.original;
    }
}

